

















































































































































































































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { marked } from 'marked'
import DOMPurify from 'dompurify'
import EventBus from '@/plugins/EventBus'
import { RepasseProjecao } from '@/types/interfaces/RepasseProjecao'
import AntecipacaoRecebiveisStore from '../RemuneracaoMedica/financeiro/Store/AntecipacaoRecebiveisStore'
import AntecipacaoDescontoRepasse from './antecipacao/antecipacao-desconto-repasse.vue'
import { formatRepasseDate, getRepasseFinal } from './antecipacao/repasseProjecao'
import ModalResumoAntecipacao from './modais/modal-resumo-antecipacao.vue'

type SimulacaoResponse = {
  taxaId: string
  parametroOperacaoId: string
  repasses: RepasseProjecao[]
}

const DEBOUNCE_MS = 300
const VALOR_MINIMO_PADRAO = 500
// Só o slider anda de 500 em 500; o valor digitado no lápis é aceito como veio (com centavos).
const SLIDER_STEP = 500

// Registro local: o require.context recursivo prefixaria a subpasta no nome da tag.
@Component({
  name: 'AntecipacaoProfissional',
  components: { AntecipacaoDescontoRepasse, ModalResumoAntecipacao },
})
export default class AntecipacaoProfissional extends Vue {
  @Prop({ required: true }) item: any

  requested: number = 0
  submetendoSolicitacao: boolean = false
  simulacao: SimulacaoResponse | null = null
  aceitouTermos: boolean = false
  mostrarModalTermos: boolean = false
  mostrarComoFunciona: boolean = false
  mostrarFaq: boolean = false
  mostrarResumo: boolean = false
  mostrarSucesso: boolean = false
  valorSolicitadoConfirmado: number = 0
  repasseFinalConfirmado: RepasseProjecao | null = null
  submitErrorMessage: string | null = null
  editandoValor: boolean = false
  valorDigitado: string = ''
  valorAbaixoDoMinimo: number | null = null
  avisoValor: string = ''

  private debounceTimer: number | null = null
  private requestSeq: number = 0
  private latestRequestSeq: number = 0
  private lastSentValor: number | null = null

  get getAntecipacaoStore() {
    return getModule(AntecipacaoRecebiveisStore, this.$store)
  }

  get creditoId(): string {
    return this.item && this.item.creditoId ? String(this.item.creditoId) : ''
  }

  get hospitalNome(): string {
    if (!this.item) return ''
    return this.item.fontePagadoraNome || this.item.empresaMedicaNome || ''
  }

  get empresaMedicaNome(): string {
    if (!this.item) return ''
    return this.item.fontePagadoraNome ? this.item.empresaMedicaNome || '' : ''
  }

  get minNetPV(): number {
    return (this.item && this.item.minNetPV) || 0
  }

  get maxNetPV(): number {
    return (this.item && this.item.maxNetPV) || 0
  }

  // Mínimo vem do parâmetro da operação (ValorMinimoAntecipacao); 500 só como fallback.
  get valorMinimo(): number {
    return this.minNetPV > 0 ? this.minNetPV : VALOR_MINIMO_PADRAO
  }

  get temLimites(): boolean {
    return this.maxNetPV > 0
  }

  get repasses(): RepasseProjecao[] {
    return this.simulacao ? this.simulacao.repasses : []
  }

  get repasseFinal(): RepasseProjecao | null {
    return getRepasseFinal(this.repasses)
  }

  get isAbaixoDoMinimo(): boolean {
    return this.valorAbaixoDoMinimo !== null
  }

  get valorEmTela(): number {
    return this.valorAbaixoDoMinimo !== null ? this.valorAbaixoDoMinimo : this.requested
  }

  get valorExibido(): string {
    return this.toCurrency(this.valorEmTela)
  }

  get dataRepasseFinalConfirmado(): string {
    return this.repasseFinalConfirmado ? formatRepasseDate(this.repasseFinalConfirmado.data) : ''
  }

  get numeroContrato(): string {
    if (!this.item) return ''
    const contrato = this.item.numeroContrato || this.item.contrato || this.item.numeroContratoFormatado
    return contrato ? String(contrato) : ''
  }

  get ultimoRepasseLabel(): string {
    if (!this.item) return ''
    const data = this.item.ultimoRepasse || this.item.dataUltimoRepasse || this.item.ultimoRepasseData
    return data ? this.formatShortDate(String(data)) : ''
  }

  get podeSubmeterSolicitacao(): boolean {
    if (this.submetendoSolicitacao) return false
    if (!this.simulacao) return false
    if (this.requested <= 0) return false
    if (this.isAbaixoDoMinimo || this.editandoValor) return false
    if (!this.aceitouTermos) return false
    if (!this.termoVigente) return false
    return true
  }

  get termoVigente(): { versao: string, texto: string } | null {
    return this.getAntecipacaoStore.termoCessaoVigente
  }

  get termoHtml(): string {
    if (!this.termoVigente) return ''
    const rawHtml = marked.parse(this.termoVigente.texto, {
      breaks: false,
      gfm: true,
    }) as string
    return DOMPurify.sanitize(rawHtml, {
      ALLOWED_TAGS: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'ul', 'ol', 'li', 'strong', 'em', 'a', 'br', 'hr', 'blockquote', 'code'],
      ALLOWED_ATTR: ['href', 'target', 'rel'],
    })
  }

  aceitarTermosPelaModal() {
    this.aceitouTermos = true
    this.mostrarModalTermos = false
  }

  comoFuncionaItems: string[] = [
    'Você escolhe quanto quer receber hoje.',
    'Mostramos o desconto estimado no próximo repasse.',
    'Se o hospital não pagar nesse repasse, usamos os próximos repasses elegíveis.',
    'Se o repasse vier parcial, liquidamos parte da antecipação e o restante segue para o próximo repasse.',
    'Tenha previsibilidade sobre o que recebe hoje e o que fica para os próximos repasses.',
  ]

  faqItems: { pergunta: string, resposta: string }[] = [
    {
      pergunta: 'O que é Antecipação Inteligente de Recebíveis - AIR?',
      resposta: 'O AIR é um programa de Antecipação Inteligente de Recebíveis, onde você recebe hoje o que só '
        + 'entraria mais para frente. Ele antecipa os valores da sua produção médica já realizada, antes mesmo '
        + 'do faturamento e do repasse do hospital. Esse é o nosso grande diferencial: enquanto as antecipações '
        + 'tradicionais só funcionam depois da emissão da nota fiscal, o Fin-X AIR reconhece os serviços que '
        + 'você já prestou e libera o adiantamento antes disso, com muito mais agilidade.',
    },
    {
      pergunta: 'Quem pode aderir ao programa de Antecipação Inteligente de Recebíveis - AIR?',
      resposta: 'O AIR está disponível para médicos e profissionais do corpo clínico constituídos como pessoa '
        + 'jurídica (PJ), que tenham produção a receber junto a um hospital participante do programa. Se o seu '
        + 'hospital já é parceiro, é só aderir para começar a usar.',
    },
    {
      pergunta: 'Como faço para antecipar meus recebíveis e quais são os critérios avaliados?',
      resposta: 'Nada complicado. É rápido e todo digital. Depois de aderir ao programa pelo seu hospital, você '
        + 'acessa a Plataforma de Remuneração Fin-X, em ambiente seguro, e já visualiza o valor disponível para '
        + 'antecipar, calculado automaticamente com base na sua produção. As condições aparecem de forma '
        + 'transparente antes de você confirmar, sem burocracia e sem letras miúdas.',
    },
    {
      pergunta: 'Quando receberei o dinheiro?',
      resposta: 'Rápido: após confirmar a antecipação, o valor é creditado na sua conta PJ em até 1 dia útil '
        + '(D+1). Como o AIR trabalha com a sua produção já realizada, e não espera a nota fiscal, você tem '
        + 'acesso ao dinheiro bem antes do que teria em uma antecipação comum.',
    },
    {
      pergunta: 'O faturamento e repasse junto ao hospital muda com a antecipação?',
      resposta: 'Não. O valor da sua produção e a forma como o hospital apura e paga continuam exatamente como '
        + 'antes. A única diferença é que o valor já antecipado passa a ser direcionado à estrutura financeira '
        + 'responsável pela antecipação, regulada, auditada e conduzida por instituições especializadas e '
        + 'independentes, o que garante segurança em toda a operação. Para o hospital, nada muda: mesmo ciclo '
        + 'de pagamento, sem custo extra e sem dívida em seu balanço.',
    },
  ]

  private parseIsoDate(s: string): Date {
    const [y, m, d] = s.split('-').map(Number)
    return new Date(y, (m || 1) - 1, d || 1)
  }

  formatShortDate(s: string): string {
    const isIso = /^\d{4}-\d{2}-\d{2}/.test(s)
    const date = isIso ? this.parseIsoDate(s) : new Date(s)
    if (Number.isNaN(date.getTime())) return s
    const label = new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(date)
    return label.replace(/\./g, '')
  }

  toCurrency(value: number): string {
    const n = Number.isFinite(value) ? value : 0
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n)
  }

  iniciarEdicaoValor() {
    if (!this.temLimites) {
      return
    }

    this.valorDigitado = this.formatValorEditavel(this.valorEmTela)
    this.avisoValor = ''
    this.editandoValor = true

    this.$nextTick(() => {
      const input = this.$refs.inputValor as HTMLInputElement | undefined

      if (input) {
        input.focus()
        input.select()
      }
    })
  }

  confirmarValorDigitado() {
    if (!this.editandoValor) {
      return
    }

    this.editandoValor = false
    const valor = this.parseValorDigitado(this.valorDigitado)

    if (valor === null) {
      return
    }

    if (valor < this.valorMinimo) {
      this.valorAbaixoDoMinimo = valor
      this.avisoValor = `O valor mínimo para antecipação é ${this.toCurrency(this.valorMinimo)}.`
      return
    }

    this.valorAbaixoDoMinimo = null

    if (valor > this.maxNetPV) {
      this.requested = this.maxNetPV
      this.avisoValor = `Valor ajustado para o máximo disponível: ${this.toCurrency(this.maxNetPV)}.`
      return
    }

    this.avisoValor = ''
    this.requested = valor
  }

  onSliderInput(valor: number) {
    // O v-slider reemite o próprio :value quando ele muda por fora (valor digitado); ignorar para não arredondar.
    if (valor === this.requested) {
      return
    }

    this.valorAbaixoDoMinimo = null
    this.avisoValor = ''
    this.requested = this.snapToSliderStep(valor)
  }

  private snapToSliderStep(valor: number): number {
    const multiplo = Math.round(valor / SLIDER_STEP) * SLIDER_STEP

    if (multiplo >= this.maxNetPV) {
      return this.maxNetPV
    }

    return Math.max(multiplo, this.valorMinimo)
  }

  // Aceita "1.250,75", "1250,75" e "1250.75"; ponto seguido de 3 dígitos é separador de milhar.
  private parseValorDigitado(texto: string): number | null {
    const limpo = (texto || '').replace(/[^\d.,]/g, '')

    if (!limpo) {
      return null
    }

    const normalizado = limpo.includes(',')
      ? limpo.replace(/\./g, '').replace(',', '.')
      : limpo.replace(/\.(?=\d{3}(\D|$))/g, '')
    const valor = Number(normalizado)

    if (!Number.isFinite(valor)) {
      return null
    }

    return Math.round(valor * 100) / 100
  }

  private formatValorEditavel(valor: number): string {
    return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor)
  }

  mounted() {
    this.seedRequestedFromLimits()
    this.scheduleSimulacao({ immediate: true })
    this.carregarTermoVigente()
  }

  private async carregarTermoVigente() {
    if (this.termoVigente) return
    await this.getAntecipacaoStore.getTermoCessaoVigente()
  }

  private seedRequestedFromLimits() {
    if (this.maxNetPV > 0) {
      this.requested = this.maxNetPV
      this.lastSentValor = this.maxNetPV
    }
  }

  beforeDestroy() {
    this.cancelPending()
  }

  private cancelPending() {
    if (this.debounceTimer !== null) {
      window.clearTimeout(this.debounceTimer)
      this.debounceTimer = null
    }
    this.latestRequestSeq = this.requestSeq + 1
  }

  @Watch('creditoId')
  onCreditoIdChange() {
    if (this.creditoId) {
      this.simulacao = null
      this.lastSentValor = null
      this.aceitouTermos = false
      this.submitErrorMessage = null
      this.editandoValor = false
      this.valorAbaixoDoMinimo = null
      this.avisoValor = ''
      this.seedRequestedFromLimits()
      this.scheduleSimulacao({ immediate: true })
    }
  }

  @Watch('requested')
  onRequestedChange(newVal: number) {
    if (!this.temLimites) return
    if (this.lastSentValor === newVal) return
    this.submitErrorMessage = null
    this.scheduleSimulacao({ immediate: false })
  }

  private scheduleSimulacao(opts: { immediate: boolean }) {
    if (!this.creditoId) return

    if (this.debounceTimer !== null) {
      window.clearTimeout(this.debounceTimer)
      this.debounceTimer = null
    }

    const fire = () => {
      this.debounceTimer = null
      this.runSimulacao()
    }

    if (opts.immediate) {
      fire()
    } else {
      this.debounceTimer = window.setTimeout(fire, DEBOUNCE_MS)
    }
  }

  private async runSimulacao() {
    if (!this.creditoId) return

    this.requestSeq += 1
    const seq = this.requestSeq
    this.latestRequestSeq = seq

    const valorSolicitado = this.temLimites ? this.requested : null
    this.lastSentValor = valorSolicitado

    const result: any = await this.getAntecipacaoStore.simularAntecipacao({
      creditoId: this.creditoId,
      valorSolicitado,
    })

    if (seq !== this.latestRequestSeq) return

    if (!result || !result.success || !result.data) return

    this.simulacao = result.data as SimulacaoResponse
  }

  abrirResumo() {
    if (!this.podeSubmeterSolicitacao) return
    this.submitErrorMessage = null
    this.mostrarResumo = true
  }

  verHistorico() {
    this.mostrarSucesso = false
    this.$emit('solicitado')
    this.$emit('ver-historico')
  }

  fecharSucesso() {
    this.mostrarSucesso = false
    this.$emit('solicitado')
  }

  async confirmarAntecipacao() {
    if (!this.podeSubmeterSolicitacao || !this.simulacao || !this.termoVigente) return
    const sim = this.simulacao
    const termo = this.termoVigente

    this.submetendoSolicitacao = true
    try {
      const payload = {
        creditoId: this.creditoId,
        valorSolicitado: this.requested,
        taxaId: sim.taxaId,
        parametroOperacaoId: sim.parametroOperacaoId,
        termosCessaoVersao: termo.versao,
      }
      const response = await this.getAntecipacaoStore.submeterSolicitacao(payload)
      if (response && response.success) {
        this.submitErrorMessage = null
        this.valorSolicitadoConfirmado = this.requested
        this.repasseFinalConfirmado = this.repasseFinal
        this.mostrarResumo = false
        this.mostrarSucesso = true
      } else {
        const mensagem = (response && response.message) || 'Falha ao enviar a solicitação.'
        this.submitErrorMessage = mensagem
        this.mostrarResumo = false
        EventBus.$emit('setSnackbar', {
          show: true,
          text: mensagem,
          icon: 'warning',
          color: '#C62828',
        })
      }
    } finally {
      this.submetendoSolicitacao = false
    }
  }
}
